import { sendServicesAndDateTime } from 'components/Appointment/actions'
import { setShoppingData, cleanShoppingData } from 'actions/shoppingData'
import { rest } from 'services'

export const removeFromCartAction =
  (commerceItemId, _rearCommerceItemId, handleTAOSDateTimeUpdate = () => {}) => (dispatch, getState) => {
    const { shoppingData: { _state }} = getState()

    rest.api.removeFromCart({ data: { commerceItemId, rearCommerceItemId: '', isPromoExist: 'true', _state }})
      .then(shoppingData => {
        const hasShoppingData = shoppingData.quotedItemAndServices && shoppingData.totalCount
        dispatch(hasShoppingData ? setShoppingData(shoppingData) : cleanShoppingData())
        hasShoppingData && handleTAOSDateTimeUpdate()
      })
      .catch(e => console.error(e))
  }

export const removeInactiveItemsFromCartAndContnue = () => async (dispatch, getState) => {
  const { shoppingData: { quotedItemAndServices, _state }} = getState()
  const inactiveItemIds = quotedItemAndServices.products
    .filter(product => !product.isActive)
    .map(product => product.commerceItemId)
    .join(',')

  const data = {
    commerceItemId: inactiveItemIds,
    rearCommerceItemId: '',
    isPromoExist: 'true',
    _state
  }

  const shoppingData = await rest.api.removeFromCart({ data })
  await dispatch(shoppingData.quotedItemAndServices ? setShoppingData(shoppingData) : cleanShoppingData())
  await dispatch(sendServicesAndDateTime(false))
}
